import React, { FC } from 'react';
import { SearchResult } from '../../store/search';
import { IconAssignment, IconSettings } from '../../icons';
import { FormattedMessage } from 'react-intl';
import Tooltip from '../Tooltip';
import IconButton from '../core/IconButton';
import { cn } from '../../helpers/classnames';

interface ResultCardProps {
  result: SearchResult;
  onClick?: (result: SearchResult, action?: string) => void;
  noTopRadius?: boolean;
}

const hoverBorder: Partial<Record<SearchResult['type'], string>> = {
  workorder: 'hover:border-workorder-500',
  entityGroup: 'hover:border-primary-500',
};

const ResultCard: FC<ResultCardProps> = ({ result, onClick, noTopRadius }) => {
  return (
    <div
      className={cn(
        'cursor-pointer border border-transparent bg-background-50 p-2 shadow-4 hover:bg-background-200',
        noTopRadius === true ? 'rounded-b' : 'rounded',
        hoverBorder[result.type] ?? 'hover:border-background-500',
      )}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick && onClick(result);
      }}
    >
      <p className="mb-2 text-base font-semibold leading-6 text-text-950">
        {result.title}
      </p>
      <p className="text-sm leading-6 text-text-800">
        {result.subtitle || ' '}
      </p>
      <div className="flex gap-1">
        {result.type === 'contractor' && (
          <>
            <Tooltip
              label={
                <FormattedMessage
                  id="search.go_to_workorderoverivew"
                  defaultMessage="Go to workorder overview"
                />
              }
            >
              <IconButton
                variant="ghost"
                size="sm"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  onClick && onClick(result, 'overview');
                }}
                icon={<IconAssignment />}
              />
            </Tooltip>
            <Tooltip
              label={
                <FormattedMessage
                  id="search.manage_contractor_organization"
                  defaultMessage="Manage contractor organization"
                />
              }
            >
              <IconButton
                variant="ghost"
                size="sm"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  onClick && onClick(result, 'manage');
                }}
                icon={<IconSettings />}
              />
            </Tooltip>
          </>
        )}
      </div>
    </div>
  );
};

export default ResultCard;
